<p-tree [value]="networkTreeNodes" selectionMode="single" (onNodeSelect)="selectionChanged($event)"></p-tree>
